export const translation = {
    error: 'Помилка',
};
//# sourceMappingURL=uk.js.map